import { categoriesBase } from './../shared/types/categories-base';
import { faLastfmSquare } from '@fortawesome/free-brands-svg-icons';

import {Component, ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
// import {MapsAPILoader} from '@agm/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Title} from '@angular/platform-browser';
import {SearchService} from '../shared/services/search_service';
import {StreamService} from '../shared/services/stream_service';
import {CategoriesService} from '../shared/services/categories_service';
import {NoteService} from '../shared/services/note_service';
import {UserService} from '../shared/services/user_service';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnChanges, OnDestroy {
    @ViewChild('locationModal', {static: false}) locationModal: ElementRef;
    loadingSearchResults = false;
    searchResult: any[] = [];
    showSearchResultLimit = 20;
    allResultsLength = 0;
    dateFromArray: any[] = [];
    isLoggedIn = false;
    extendedCatArray = ['news-local', 'news-state', 'news-us'];
    extendedLocationLabel: string;
    localSearchObject: any = {};
    localLocationSearchData: any = {};
    localProfileInfoData = [];

    // eslint-disable-next-line @typescript-eslint/ban-types
    public searchFormProps: {} = {
        customClass: 'col search-box',
        showIcon: true,
        iconSide: 'left',
        showButton: false,
        inputPlaceholder: 'Search',
        buttonText: ''
    };

    public filters = {
        categories: {
            visible: false,
            label: 'All categories',
            labelFilled: false,
            categories: []
        },
        location: {
            visible: false,
            range: 500,
            label: 'Anywhere',
            labelFilled: false
        },
        media: {
            visible: false,
            labelFilled: false,
            options: [
                {label: 'Any type', value: '', selected: false},
                {label: 'Text', value: 'kind-text', selected: false},
                {label: 'Audio', value: 'kind-audio', selected: false}
            ],
            label: 'All media',
        },
        time: {
            visible: false,
            options: [
                {label: 'Anytime', value: 0, timestamp: 0, selected: false},
                {label: '7 days ago', value: 7, timestamp: 0, selected: false},
                {label: '30 days ago', value: 30, timestamp: 0, selected: false}
            ],
            label: 'Anytime',
            labelFilled: false
        }
    };

    public urlParams: any = {
        query: '',
        category: '',
        type: 'notes'
    };

    private getSearchDataSub: any;
    private getPostsSub: any;
    private routeParamsSub: any;

    constructor(
        public searchService: SearchService,
        private noteService: NoteService,
        private categoriesService: CategoriesService,
        private userService: UserService,
        public route: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
        private titleService: Title
    ) { }

    ngOnInit() {
      this.titleService.setTitle('Search - notd.io');
      this.isLoggedIn = this.userService.isLoggedIn();

      this.routeParamsSub = this.route.params.subscribe(() => {
        this.setDateSelectorData();
        this.getSearchParams();
        this.searchForResults();
      });

      this.searchService.searchParamsSubject.subscribe(() => {
        this.searchForResults();
      });

      this.getCategories();
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log('changes: ', changes);
    }

    getSearchParams() {
        let tags: any = [];

        const queryString = !!this.route.params['value']['query'] ? this.route.params['value']['query'] : '' ;
        const type = !!this.route.params['value']['type'] ? this.route.params['value']['type'] : '';

        if (!!this.route.params['value']['form'] && this.route.params['value']['form'] !== 'all') {
            tags.push(`type-${this.route.params['value']['form']}`);
        }

        if (!!this.route.params['value']['category'] && this.route.params['value']['category'] !== 'all') {
            tags.push(`category-${this.route.params['value']['category']}`);
        }

        tags = (tags.length > 0) ? tags.join(',') : '';

        const selectedDate = this.getSelectedDate();

        const currentCategory = this.route.params['value']['form'] ?
            this.route.params['value']['form'].replace(/[^a-zA-Z0-9]/g, '-') : '';

        const currentSubCategory = this.route.params['value']['category'] ?
            this.route.params['value']['category'].replace(/[^a-zA-Z0-9]/g, '-') : '';

        this.urlParams = {
            query: queryString,
            type,
            category: currentCategory,
            subcategory: currentSubCategory
        };

        this.searchService.setSearchParams({
            query: queryString,
            type,
            tags,
            fromDate: selectedDate,
            fromOffset: 0,
            size: 20
        });

        this.getSelectedCategoriesFromRoute();
        this.getSelectedMediaFilter();

    }

    searchForResults() {
        const type = 'notes';
        this.loadingSearchResults = true;
        const currentOffset = this.searchService.getSearchParams().fromOffset;
        this.searchResult = currentOffset === 0 ? [] : this.searchResult;

        this.getSearchDataSub = this.searchService.getNotes().subscribe((res: any) => {
            if (currentOffset === 0) {
                this.searchResult = res['posts'];
            } else {
                const currentSearchResults = this.searchResult;
                this.searchResult = currentSearchResults.concat(res['posts']);
            }

            const total = res['total'] ? res['total'] : this.searchResult.length;

            if (type === 'notes') {
                this.getParentNoteInfo();
            }

            this.allResultsLength = total || 0;
            this.loadingSearchResults = false;
        }, err => {
          console.error(err.error || err);
        });
    }

    public triggerFilter(filter: string, status?: boolean): void {
        if (status) {
            this.filters[filter].visible = status;
        } else {
            this.filters[filter].visible = !this.filters[filter].visible;
        }
    }

    public setLocationFilterData(): void {
        this.triggerFilter('location', false);
        const locationRange = this.filters.location.range;

        this.searchService.setSearchParams({
            fromOffset: 0,
            location: this.localLocationSearchData,
            distance: locationRange && locationRange >= 500 ? '' : locationRange
        });

        this.setFilterLabel('location');
    }

    public restLocationFilter(): void {
        this.localLocationSearchData = {};
        this.searchService.setSearchParams({
            fromOffset: 0,
            location: '',
            distance: ''
        });
        this.filters.location.range = 500;
        this.filters.location.label = 'Anywhere';
        this.filters.location.labelFilled = false;
    }

    public setTimelineFilter(option: {'label': string; 'value': number; timestamp: number; selected: boolean}): void {
        for (const o of this.filters.time.options) {
            o.selected = option.value === o.value && option.value > 0;
        }

        this.searchService.setSearchParams({
            fromOffset: 0,
            fromDate: option.value > 0 ? option.timestamp : ''
        });

        this.setFilterLabel('time');
    }

    public restTimeFilter(): void {
        this.searchService.setSearchParams({
            fromOffset: 0,
            fromDate: ''
        });

        for (const o of this.filters.time.options) {
            o.selected = false;
        }

        this.filters.time.label = 'Anytime';
        this.filters.time.labelFilled = false;
    }

    public setMediaFilter(option: {'label': string; 'value': string | number; selected: boolean}): void {
        for (const o of this.filters.media.options) {
            o.selected = option.value === o.value && o.value !== '';
        }

        this.searchService.setSearchParams({
            fromOffset: 0,
            mediaTag: option.value
        });

        this.setFilterLabel('media');
    }

    public restMediaFilter(): void {
        this.searchService.setSearchParams({
            fromOffset: 0,
            mediaTag: ''
        });

        for (const o of this.filters.media.options) {
            o.selected = false;
        }

        this.filters.media.label = 'All media';
        this.filters.media.labelFilled = false;
    }

    public loadMoreSearchResults(): void {
        const currentOffset = this.searchService.getSearchParams().fromOffset;
        this.searchService.setSearchParams({
          size: this.showSearchResultLimit,
          fromOffset: currentOffset + this.showSearchResultLimit
        });
    }

    selectSearchType(type: string) {
        const queryString = !!this.route.params['value']['query'] ? this.route.params['value']['query'] : '' ;
        if (!this.route.params['value']['form'] && !this.route.params['value']['category'] && this.route.params['value']['query']) {
            this.router.navigate(['/search/query', type, queryString]);
        }
        if (this.route.params['value']['form'] && this.route.params['value']['category']) {
            this.router.navigate(
                ['/search', this.route.params['value']['form'], this.route.params['value']['category'], type, queryString]
            );
        }
    }


    getCategoryLabel(cat: string) {
        return (cat !== 'all' && cat) ? this.categoriesService.getCategoryLabel(cat) : 'All categories';
    }

    onRateChange(ratingLevel: Event | number) {
        if (ratingLevel) {
            this.searchResult = [];
            this.searchService.setSearchParams({
                ratingMin: ratingLevel,
                fromOffset: 0
            });
        }
    }

    public setDateFrom(ev: Event | any) {
        const selectedDate = ev.target.value;

        for (const d of this.dateFromArray) {
            d.selected = d.value === selectedDate ? true : false;
        }

        this.searchService.setSearchParams({
            fromOffset: 0,
            fromDate: selectedDate,
        });
    }


    public geoLocatorEvent(event: Event) {
        this.localLocationSearchData = Object.assign(this.localLocationSearchData, event);
    }

    ngOnDestroy() {
      if (this.getSearchDataSub) {
        this.getSearchDataSub.unsubscribe();
      }

      if (this.getPostsSub) {
        this.getPostsSub.unsubscribe();
      }

      if (this.routeParamsSub) {
        this.routeParamsSub.unsubscribe();
      }
    }

    private getSelectedCategoriesFromRoute(): void {
        const categoriesFilter = this.filters.categories;
        const label = [];

        for (const cat of categoriesFilter.categories) {
            const category: any = cat;

            if (category.type === this.urlParams.category) {
                label.push(category.typeLabel);
                for (const subc of category.categories) {
                    const subcategory: any = subc;

                    if (subcategory.category === this.urlParams.subcategory) {
                        label.push(subcategory.label);
                    }
                }
            }
        }

        if (label.length > 0) {
            categoriesFilter.labelFilled = true;
            categoriesFilter.label = label.length > 1 ? label.join(' / ').toString() : label.toString();
        } else {
            categoriesFilter.labelFilled = false;
            categoriesFilter.label = 'All categories';
        }
    }

    private getSelectedMediaFilter(): void {
        const selectedMediaFilter = this.searchService.searchParams && this.searchService.searchParams.mediaTag ?
          this.searchService.searchParams.mediaTag : '';
        const mediaFilterOptions = this.filters.media.options;
        if (selectedMediaFilter) {
          for (const f of mediaFilterOptions) {
            if (selectedMediaFilter === f.value) {
                this.setMediaFilter(f);
            }
          }
        }
      }

    private setFilterLabel(filter: string): void {
        const seletedFilter = this.filters[filter];
        switch (filter) {
            case 'location':
                let label = '';
                if (seletedFilter.range && seletedFilter.range > 0 && seletedFilter.range < 500) {
                    label += `${seletedFilter.range} km`;
                }
                if (this.localLocationSearchData && this.localLocationSearchData.address) {
                    label += (label ? ', ' : '') + this.localLocationSearchData.address;
                }
                if (label) {
                    seletedFilter.label = label;
                    seletedFilter.labelFilled = true;
                } else {
                    seletedFilter.label = 'Anywhere';
                    seletedFilter.labelFilled = false;
                }
                break;
            case 'time':
                if (seletedFilter.options.filter(o => o.selected).length) {
                    seletedFilter.label = seletedFilter.options.filter(o => o.selected)[0].label;
                    seletedFilter.labelFilled = true;
                } else {
                    seletedFilter.label = 'Anytime';
                    seletedFilter.labelFilled = false;
                }
                break;
            case 'media':
                if (seletedFilter.options.filter(o => o.selected).length) {
                    seletedFilter.label = seletedFilter.options.filter(o => o.selected)[0].label;
                    seletedFilter.labelFilled = true;
                } else {
                    seletedFilter.label = 'All media';
                    seletedFilter.labelFilled = false;
                }
                break;
        }
    }

    private getParentNoteInfo(): void {
        this.searchResult.map(note => {
            if (note.parentPostId) {
                this.noteService.getNoteInfo(note.id).then(noteInfo => {
                    Object.assign(note, {
                        parentNote : noteInfo
                    });
                });
            }
        });
    }

    private getCategories(): void {
        const categories = this.categoriesService.getStructure();
        this.filters.categories.categories = categories;
        this.getSelectedCategoriesFromRoute();
    }

    private setDateSelectorData() {
        for (const option of this.filters.time.options) {
            const value = option.value;
            option.timestamp = Date.now() - 86400000 * value;
        }
    }

    private getSelectedDate() {
        let selectedDate: any;
        for (const d of this.dateFromArray) {
            if (d.selected) {
                selectedDate = d;
            }
        }

        return selectedDate ? selectedDate : this.dateFromArray[0];
    }
}
